import { render, staticRenderFns } from "./TemplateSelectionDraftsPanel.vue?vue&type=template&id=c04a8f66&scoped=true"
import script from "./TemplateSelectionDraftsPanel.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionDraftsPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionDraftsPanel.vue?vue&type=style&index=0&id=c04a8f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04a8f66",
  null
  
)

export default component.exports